export const fileUpBoxStyle = {
  width: '100%',
  background: '#FFFFFF',
  border: '3px dashed #EEEEEE',
  borderRadius: '4px',
  textAlign: 'center',
  padding: '16px',
  position: 'relative',
}
export const fileUpAreaMaskStyle = {
  width: '100%',
  border: '3px dashed #EEEEEE',
  borderRadius: '4px',
  textAlign: 'center',
  padding: '16px',
  position: 'relative',
  background: '#F7F7F7',
}

export const fileUpAreaMaskAreaStyle = {
  position: 'absolute',
  width: '100%',
  height: '136px',
  top: 0,
  left: 0,
  zIndex: 10,
  opacity: 0,
}

export const fileUpAreaStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const LabelStyles = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#000000',
}